(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-rewards-block"] && !Shopify.designMode) return;
  try {
    class ProductRewardsBlock extends HTMLElement {
  constructor() {
    super();
    this.unsubscribers = [];
  }

  connectedCallback() {
    const unsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      this.updatePointsText(event.data.variant.price, event.data.variant);
    });
    this.unsubscribers.push(unsubscriber);
  }

  /**
   * Updates the points text in the rewards block when the variant price changes.
   * @param {number} newPrice - The new price of the variant.
   * @param {object} variant - The variant object
   * @returns {void}
   */
  updatePointsText(newPrice, variant) {
    const pointsSpans = this.querySelectorAll('.product-rewards-block__text-points');
    const title = (variant?.title || '').toLowerCase();
    const tokenEbook = (this.dataset.tokenEbook || '').toLowerCase();
    const tokenKoboEbook = (this.dataset.tokenKoboEbook || '').toLowerCase();
    const tokenKoboAudiobook = (this.dataset.tokenKoboAudiobook || '').toLowerCase();
    const isKoboProduct = this.dataset.isKoboProduct === 'true';
    const nonEligibleVariantIds = (this.dataset.plumNonEligibleVariantIds || '')
      .split(',')
      .map(id => Number(id.trim()))
      .filter(Boolean);
    const variantId = Number(variant?.id);
    const isNonEligibleVariant =
      Number.isFinite(variantId) && nonEligibleVariantIds.includes(variantId);
    const isEbook =
      (tokenEbook && title.includes(tokenEbook)) ||
      (tokenKoboEbook && title.includes(tokenKoboEbook)) ||
      (tokenKoboAudiobook && title.includes(tokenKoboAudiobook));

    if (isKoboProduct || isEbook || isNonEligibleVariant) {
      _.addClass(this, 'hidden');
    } else {
      _.removeClass(this, 'hidden');
    }

    if (!pointsSpans.length) return;
    const pointsRatio = Number(this.dataset.pointsRatio);
    const points = Math.ceil((newPrice / 100) * pointsRatio);

    const label =
      points === 1
        ? this.dataset.rewardsPointsSingular
        : this.dataset.rewardsPointsPlural;

    pointsSpans.forEach((span) => {
      span.textContent = `${points} ${label}`;
    });
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }
}

if (!customElements.get("product-rewards-block")) {
  customElements.define("product-rewards-block", ProductRewardsBlock);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-availability-date"] && !Shopify.designMode) return;
  try {
    class ProductAvailabilityDate extends HTMLElement {
    constructor() {
      super();
      this.controller = new AbortController();

      this.c = {
        cls: {
          hide: 'product-availability-date--hide',
          revealTime: 'product-availability-date__time--reveal',
        }
      }
    }

    connectedCallback() {
      const showLabels = this.hasAttribute('data-show-labels');
      if (!showLabels) return;

      document.addEventListener('sdg:fulfillment:state-changed', (event) => {
        this.renderFromState(event.detail || {});
      }, {
        signal: this.controller.signal,
      });

      // Initial render if not hidden
      const isHidden = this.hasAttribute('aria-hidden') && this.getAttribute('aria-hidden') === 'true';
      if (!isHidden) {
        this.renderFromState({
          isPreorder: this.dataset.isPreorder === 'true',
          isPreorderNotify: this.dataset.isPreorderNotify === 'true',
          releaseDateIso: this.dataset.releaseDateIso,
        });
      }
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    renderFromState(state) {
      const isRegularNotify = !!state.isRegularNotify;
      const showDate = (!!state.isPreorder || !!state.isPreorderNotify) && !isRegularNotify;
      if (!showDate) {
        this.classList.add(this.c.cls.hide);
        this.setAttribute('aria-hidden', 'true');
        return;
      }

      const visibleText = this.formatVisibleText({
        isoDate: state.releaseDateIso,
        isPreorderNotify: !!state.isPreorderNotify,
      });

      if (!visibleText) {
        this.classList.add(this.c.cls.hide);
        this.setAttribute('aria-hidden', 'true');
        return;
      }
      // Update semantic <time> and reveal
      const timeEl = this.querySelector('time');
      this.updateTimeElement({ timeEl, visibleText, isoDate: state.releaseDateIso });
      this.classList.remove(this.c.cls.hide);
      this.removeAttribute('aria-hidden');
    }

    updateTimeElement({ timeEl, visibleText, isoDate }) {
      if (!timeEl) return; // early return if not found

      timeEl.textContent = visibleText;
      if (isoDate) timeEl.setAttribute('datetime', isoDate);
      timeEl.classList.add(this.c.cls.revealTime);
    }

    formatVisibleText({ isoDate, isPreorderNotify }) {
      const template = (isPreorderNotify ? this.dataset.fallbackTemplate : this.dataset.labelTemplate)
        || this.dataset.fallbackTemplate
        || 'Available [date]';
      const lang = this.dataset.shopLocale || 'en-CA';
      const timeZone = this.dataset.timezone || 'America/Toronto';
      const ssrText = this.dataset.releaseDateText || '';

      let text = '';
      if (isoDate) {
        try {
          // Create a proper ISO string with Toronto timezone offset
          const tempDate = new Date(isoDate + 'T12:00:00Z');
          const offsetParts = new Intl.DateTimeFormat('en', {
            timeZone,
            timeZoneName: 'longOffset'
          }).formatToParts(tempDate);
          const rawOffset = offsetParts.find(part => part.type === 'timeZoneName')?.value || 'GMT+00:00';
          // Remove 'GMT' prefix to get just the offset (e.g., 'GMT-04:00' → '-04:00')
          const offset = rawOffset.replace('GMT', '');

          // Use the ISO date with proper timezone offset (midnight Toronto time)
          const fullIsoString = isoDate + 'T00:00:00' + offset;
          text = new Intl.DateTimeFormat(lang, { year: 'numeric', month: 'long', day: 'numeric', timeZone })
            .format(new Date(fullIsoString));
        } catch (e) {
          console.warn('Error formatting release date:', e);
        }
      }
      if (!text) text = ssrText || '';
      if (!text) return '';
      return template.replace('[date]', text);
    }
  }

  if (!customElements.get('product-availability-date')) {
    customElements.define('product-availability-date', ProductAvailabilityDate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-availability-tag"] && !Shopify.designMode) return;
  try {
    class ProductAvailabilityTag extends HTMLElement {
    constructor() {
      super();
      this.controller = new AbortController();

      this.c = {
        cls: {
          hide: 'product-availability-tag--hide',
        }
      }
    }

    connectedCallback() {
      const showLabels = this.hasAttribute('data-show-labels');
      if (!showLabels) return;

      const targetVariantId = this.dataset.variantId;
      const targetProductId = this.dataset.productId;
      const targetPickerId = this.dataset.pickerId;

      document.addEventListener('sdg:fulfillment:state-changed', (event) => {
        const state = event.detail || {};

        // Filter: only process events that match this tag's identifiers
        let shouldProcess = false;

        if (targetPickerId && state.pickerId === targetPickerId) {
          shouldProcess = true;
        } else if (targetVariantId && state.variantId === targetVariantId) {
          shouldProcess = true;
        } else if (targetProductId && state.productId === targetProductId && !targetVariantId) {
          shouldProcess = true;
        }

        if (!shouldProcess) {
          return;
        }

        this.renderFromState(state);
      }, {
        signal: this.controller.signal,
      });
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    renderFromState(state) {
      const isRegularNotify = !!state.isRegularNotify;
      const isPreorder = !!state.isPreorder && !isRegularNotify;
      let isComingSoon = !!state.isComingSoon && !isRegularNotify;

      const releaseDate = state.releaseDateIso ? new Date(state.releaseDateIso) : null;
      const now = new Date();
      if (isComingSoon && releaseDate && releaseDate < now) {
        isComingSoon = false;
      }

      if (!isPreorder && !isComingSoon) {
        this.classList.add(this.c.cls.hide);
        this.setAttribute('aria-hidden', 'true');
        return;
      }

      this.classList.remove(this.c.cls.hide);
      this.removeAttribute('aria-hidden');

      const preOrderText = this.dataset.preOrderText || 'PRE-ORDER';
      const comingSoonText = this.dataset.comingSoonText || 'COMING SOON';
      const text = isPreorder ? preOrderText : comingSoonText;
      const stateAttr = isPreorder ? 'preorder' : 'coming-soon';

      this.setAttribute('data-state', stateAttr);
      this.textContent = text;
    }
  }

  if (!customElements.get('product-availability-tag')) {
    customElements.define('product-availability-tag', ProductAvailabilityTag);
  }
  } catch(e) { console.error(e); }
})();

})();
